import type React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { PlaceField } from 'src/app/shared/components/googlePlaces';

import { useLocation } from './hooks/useLocation';

export const Location: React.FC = () => {
	const { translate, typedTranslate } = useI18n();
	const { data, actions } = useLocation();

	if (data.geoReach !== 'local') return null;

	return (
		// TODO: All the styling changes made below for the PlaceField component should be cleaned when we migrate this component to use the new DS components.
		<div
			id="petition_location"
			className="[&_label_span]:text-size-body-small [&_label_span]:text-typography-strong -mt-4 [&_#petition-place]:h-[52px] [&_#petition-place]:font-sans [&_label_span]:font-sans [&#petition-place+div]:mt-2.5!"
		>
			<PlaceField
				label={translate('corgi.petition.edit.petition_data.location.title')}
				geoScope={data.geoReach}
				onSelect={actions.onSelect}
				defaultPlaceValue={data.place}
				error={data.error ? typedTranslate(data.error) : null}
			/>
		</div>
	);
};
